var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1762 28.3697C17.3589 28.3697 17.5255 28.2799 17.6231 28.1357L17.6232 28.1356L17.6249 28.133L17.6321 28.1224L17.661 28.0793C17.6865 28.0411 17.7245 27.9841 17.7738 27.9097C17.8723 27.7609 18.0158 27.5425 18.1946 27.2657C18.5525 26.7119 19.0517 25.9248 19.616 24.9931C20.7468 23.1261 22.1302 20.6933 23.1637 18.3992C24.1192 16.2772 24.7222 14.3405 24.7222 13.0324C24.7222 8.95832 21.351 5.63027 17.1762 5.63027C13.0015 5.63027 9.63027 8.95832 9.63027 13.0324C9.63027 14.3405 10.2333 16.2772 11.1888 18.3992C12.2223 20.6933 13.6057 23.1261 14.7365 24.9931C15.3008 25.9248 15.8 26.7119 16.1578 27.2657C16.3367 27.5425 16.4802 27.7609 16.5787 27.9097C16.628 27.9841 16.666 28.0411 16.6915 28.0793L16.7204 28.1224L16.7276 28.133L16.7293 28.1356L16.7293 28.1357C16.7294 28.1358 16.7295 28.1359 16.7296 28.1361C16.8273 28.2801 16.9937 28.3697 17.1762 28.3697ZM17.7084 26.0752L17.1762 26.9137L16.6441 26.0752C15.4864 24.2512 13.5276 21.0182 12.1652 17.9933C11.3623 16.2128 10.6936 14.4024 10.6936 13.0324C10.6936 9.50052 13.609 6.65373 17.1762 6.65373C20.7435 6.65373 23.6589 9.50052 23.6589 13.0324C23.6589 14.4024 22.9902 16.2128 22.1873 17.9933C20.8249 21.0182 18.8661 24.2512 17.7084 26.0752Z",
    fill: "#1B293E",
    stroke: "#1B293E",
    strokeWidth: 1.26055
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16C18.1046 16 19 15.1046 19 14C19 12.8954 18.1046 12 17 12C15.8954 12 15 12.8954 15 14C15 15.1046 15.8954 16 17 16Z",
    fill: "#1B293E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ab700a9bd2134b03f0f53994d2c84d9b.svg";
export { ForwardRef as ReactComponent };